export const BackgroundCheck = {
  HeaderText: 'header-text',
};

export const BackgroundCheckBlocked = {
  HeaderText: 'header-text',
};
